import React, { useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Router from 'next/router';
import Head from 'next/head';
import Header from '../components/Header';
import { DEFAULT_ADDRESS, DEFAULT_DATETIME, DEFAULT_LOCATION } from '../constants/default';
import notificationTypes from '../constants/modalNotificationConst';
import { getAddress } from '../helpers/addressHelper';
import loadScript from '../helpers/loadScript';


import MapPinLocation from '../components/mapboxMapPinLocation';
import { setRollbarWarning } from '../helpers/rollBar';
import getHost from '../helpers/gethost';
import useAPI from '../NetworkCall/API';
import pageDisable from '../helpers/pageDisableHelper';
// import appConfig from '../appConfig';
import { useDispatch, useSelector } from 'react-redux';
import { pushNotification } from '../redux/slices/modalSlice';
import { saveLocation, setDeliverySelectedFromProfileMap } from '../redux/slices/userSlice';
import { updateNewAddressForProfile } from '../redux/slices/otherSlice';
import { useConfigData } from '../Context/ConfigProvider';
import { withConfig } from '../lib/withConfig';

const canonicalHref = `https://${getHost()}/locationselect`;

const LocationSelect = () => {
  const [coordinates, setCoordinates] = useState({});
  const [googleLoaded, setGoogleLoaded] = useState(false);

  // const {
  //   state: { user: { deliveryDetails } = {} },
  //   dispatch
  // } = useContext(appContext);
  const deliveryDetails = useSelector(state => state.user.deliveryDetails)
  const dispatchRedux = useDispatch()

  const { addAddress, checkZipCodeStatus } = useAPI();
  const appConfig = useConfigData();
  useEffect(() => {
    async function loadGoogle() {
      if (!window.google) {
        await loadScript({
          url: `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY}&callback=Function.prototype&v=3.exp&libraries=geometry,drawing,places`
        });
      }
      setGoogleLoaded(true);
    }
    loadGoogle();
  }, []);

  async function getPinLocation(locationObject) {
    // setting the location object to user store if valid and moving back to landing page with popup open
    if (locationObject.postcode && locationObject.city) {
      const newDeliveryDetails = {
        address: locationObject.address,
        latitude: locationObject.latitude,
        longitude: locationObject.longitude,
        placeId: locationObject.placeId,
        postcode: locationObject.postcode,
        city: locationObject.city,
        state: locationObject.state,
        country: locationObject.country,
        streetNumber: locationObject.streetNumber,
        streetName: locationObject.streetName,
        deliveryDateTime: DEFAULT_DATETIME,
        fromMap: true
      };
      // If user is from /profile/addresses, navigationg back to same
      if (Router.query.fromProfile) {
        const { address_id, is_default, address_type, address_type_name, is_new } = Router.query;
        const { address, latitude, longitude, postcode, city, state, placeId, country } = newDeliveryDetails;
        const data = await checkZipCodeStatus(newDeliveryDetails);
        if (!data.validZipcode && !data.error) {
          toast.error(`It looks like your location is outside of ${appConfig.APP_NAME}’s service area.`);
          return false;
        }
        const payload = {
          address_id: parseInt(address_id),
          is_default: parseInt(is_default),
          address_type: parseInt(address_type),
          address_type_name,
          address,
          address_1: address,
          latitude,
          longitude,
          postcode,
          city,
          state,
          place_id: placeId,
          country
        };
        if (is_new == "true") {
          // dispatch({
          //   type: 'setDeliverySelectedFromProfileMap',
          //   payload: { deliverySelectedFromProfileMap: true }
          // });
          dispatchRedux(setDeliverySelectedFromProfileMap({ deliverySelectedFromProfileMap: true }))
        }
        // dispatch({
        //   type: 'updateNewAddressForProfile',
        //   payload: { ...payload }
        // });
        dispatchRedux(updateNewAddressForProfile({ ...payload }))
        Router.push('/profile/addresses');
      }
      // dispatch({ type: 'saveLocation', payload: newDeliveryDetails });
      dispatchRedux(saveLocation(newDeliveryDetails))
      Router.back();
      dispatchRedux(pushNotification({ type: notificationTypes.deliveryAddressDetail }))
    } else {
      toast.warn('Please select a precise address');
    }
  }

  function getAddressObject() {
    if (deliveryDetails && deliveryDetails.latitude) {
      return {
        latitude: parseFloat(deliveryDetails.latitude),
        longitude: parseFloat(deliveryDetails.longitude),
        address: deliveryDetails.address
      };
    }
    return { latitude: parseFloat(DEFAULT_LOCATION.lat), longitude: parseFloat(DEFAULT_LOCATION.lng), address: DEFAULT_ADDRESS };
  }

  // take the location from state and apply it call google places api to get location object from the helper
  async function setLocation() {
    try {
      const addressObj = await getAddress({ ...coordinates });
      getPinLocation(addressObj);
    } catch (error) {
      setRollbarWarning('locationSelect.js_setLocation_catch', error);
      console.error('locationSelect.js_setLocation_catch', error);
    }
  }

  // setting location from the map to state everytime it moves
  function saveCoordinates(coord) {
    setCoordinates(coord);
  }

  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalHref} />
      </Head>
      <Header minimalNavbar hasText backPath toPath="/deliverydetails" pageName="" hideCartIcon />
      <div className="location-select">
        <div className="map-parent">
          {googleLoaded && <MapPinLocation currentLocation={getAddressObject()} setCoordinates={saveCoordinates} />}
        </div>
        <button
          disabled={!googleLoaded}
          type="button"
          className="btn btn-primary rouded-button text-uppercase set-location"
          onClick={setLocation}
        >
          <div className="s-text">Set Delivery Location</div>
          <div className="icon-down" />
        </button>
      </div>
    </>
  );
};

async function getServerSidePropsFunction({ req, res, query: { tab } = {} }) {
  return {
    props: {}
  }
}
export const getServerSideProps = withConfig(getServerSidePropsFunction)
export default pageDisable(LocationSelect);
